/* const SET_RIL_REPORTS = (state, payload) => {
  state.results = payload;
} */

const SET_ALL_BIRTHS = (state, payload) => {
  state.results = payload;
}

const CLEAN_RESULTS = (state) => {
  state.results = []
}

export default {
  SET_ALL_BIRTHS,
  CLEAN_RESULTS
}